import { render, staticRenderFns } from "./pub_easy_one.vue?vue&type=template&id=7c20cff5&scoped=true&"
import script from "./pub_easy_one.vue?vue&type=script&lang=js&"
export * from "./pub_easy_one.vue?vue&type=script&lang=js&"
import style0 from "./pub_easy_one.vue?vue&type=style&index=0&id=7c20cff5&scoped=true&lang=less&"
import style1 from "./pub_easy_one.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c20cff5",
  null
  
)

export default component.exports